import React, { useState, useEffect } from 'react';
import MBookingCard from './MBookingCard';
import NoRide from './NoRide';

function MyRideBoth() {
  const [hasRides, setHasRides] = useState(null);

  useEffect(() => {
    // Simulate an API call
    const fetchRides = async () => {
      const ridesAvailable = true; // Ranjita Gouri  ==? it should be false 
      setHasRides(ridesAvailable);
    };

    fetchRides();
  }, []);

  if (hasRides === null) {
    return <p>Loading...</p>; // Show a loading state while fetching data
  }

  return (
    <div>
      {hasRides ? <MBookingCard /> : <NoRide />}
    </div>
  );
}

export default MyRideBoth;

